export default class AbstractWeatherModel {
  setValuesFromApi(data, observation) {
    this.observationId = observation.id
    this.apiCalled = data.apiCalled
    this.calculationTimeMilliSeconds = data.calculationTimeMilliSeconds
    this.lat = data.lat
    this.lon = data.lon
    this.geohash = data.geohash
  }
}
